import React from "react";

export function Brands() {
  return (
    <>
      <div className="flex md:gap-[43px] gap-[23px] mt-[43px] flex-wrap justify-center">
        <img
          className="md:max-w-[200px] max-w-[100px] "
          src="/img/Tenn.png"
          alt=""
        />
        <img
          className="md:max-w-[137px] max-w-[70px]"
          src="/img/Jasuragi.png"
          alt=""
        />
        <img
          className="md:max-w-[163px] max-w-[80px]"
          src="/img/marimekko-logo.png"
          alt=""
        />
        <img
          className="md:max-w-[120px] max-w-[60px]"
          src="/img/louis-poulsen-logo-vector.png"
          alt=""
        />
        <img
          className="md:max-w-[170px] max-w-[85px]"
          src="/img/globalol-logo.png"
          alt=""
        />
      </div>
    </>
  );
}
